import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2;

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import Base from "./Base";
import { computed, observable, makeObservable, runInAction } from "mobx";
import DPServices from "@dp/services";
import MobileAccordionModel from "./models/MobileAccordionModel";
import i18next from "i18next";
import { PlatformType } from "@dp/common";
import { OTAModel } from "./models";
var Common = (_class = /*#__PURE__*/function (_Base) {
  _inherits(Common, _Base);

  var _super = _createSuper(Common);

  function Common(rootStore) {
    var _this;

    _classCallCheck(this, Common);

    _this = _super.call(this);

    _initializerDefineProperty(_assertThisInitialized(_this), "_appAttributes", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_timeAtAppActive", _descriptor2, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "accordionModel", null);

    _defineProperty(_assertThisInitialized(_this), "rootStore", void 0);

    _defineProperty(_assertThisInitialized(_this), "otaModel", null);

    _this.rootStore = rootStore;
    _this.accordionModel = new MobileAccordionModel(_this.rootStore.platformUtil);

    if (_this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.APP) {
      _this.otaModel = new OTAModel(_this.rootStore.platformUtil);
    }

    makeObservable(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Common, [{
    key: "setupReactions",
    value: function setupReactions() {
      return;
    }
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var appAttributes;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return DPServices.Common.getAppAttributes();

              case 2:
                appAttributes = _context.sent;
                DPServices.Config.setConceptCode(appAttributes.currentConceptCode);
                runInAction(function () {
                  _this2._appAttributes = appAttributes;
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "refresh",
    value: function () {
      var _refresh = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function refresh() {
        return _refresh.apply(this, arguments);
      }

      return refresh;
    }()
  }, {
    key: "reset",
    value: function () {
      var _reset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function reset() {
        return _reset.apply(this, arguments);
      }

      return reset;
    }()
  }, {
    key: "getCurbsideTokenIdentifier",
    value: function getCurbsideTokenIdentifier() {
      var _this$rootStore, _this$rootStore$user, _this$rootStore2, _this$rootStore2$user, _this$rootStore2$user2, _this$rootStore2$user3;

      var isUserLoggedIn = (_this$rootStore = this.rootStore) === null || _this$rootStore === void 0 ? void 0 : (_this$rootStore$user = _this$rootStore.user) === null || _this$rootStore$user === void 0 ? void 0 : _this$rootStore$user.isLoggedIn;
      var TOKEN_IDENTIFIER = isUserLoggedIn ? (_this$rootStore2 = this.rootStore) === null || _this$rootStore2 === void 0 ? void 0 : (_this$rootStore2$user = _this$rootStore2.user) === null || _this$rootStore2$user === void 0 ? void 0 : (_this$rootStore2$user2 = _this$rootStore2$user.userProfile) === null || _this$rootStore2$user2 === void 0 ? void 0 : (_this$rootStore2$user3 = _this$rootStore2$user2.login) === null || _this$rootStore2$user3 === void 0 ? void 0 : _this$rootStore2$user3.toUpperCase() : "ANONYMOUS";
      return TOKEN_IDENTIFIER;
    }
  }, {
    key: "appAttributes",
    get: function get() {
      return this._appAttributes;
    }
  }, {
    key: "mobilePayLoginEnforced",
    get: function get() {
      var appAttributes = this.appAttributes;
      var isWebMobilePayLoginEnforced = appAttributes.isWebMobilePayLoginEnforced;
      var isMobilePayForVIPGuestsEnabled = appAttributes.isMobilePayForVIPGuestsEnabled;
      return isMobilePayForVIPGuestsEnabled || isWebMobilePayLoginEnforced;
    }
  }, {
    key: "timeAtAppActive",
    get: function get() {
      return this._timeAtAppActive;
    },
    set: function set(_timeAtAppActive) {
      var _this3 = this;

      runInAction(function () {
        _this3._timeAtAppActive = _timeAtAppActive;
      });
    }
  }, {
    key: "shouldShowGlobalBanner",
    get: function get() {
      return this.isGlobalBannerMessageAvailableInRB || this.isCareersLinkAvailableInRB;
    }
  }, {
    key: "isGlobalBannerMessageAvailableInRB",
    get: function get() {
      return !!i18next.t("header.richtext.globalBannerMessage");
    }
  }, {
    key: "isCareersLinkAvailableInRB",
    get: function get() {
      return !!i18next.t("header.label.careers");
    }
  }]);

  return Common;
}(Base), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_appAttributes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_timeAtAppActive", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "appAttributes", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "appAttributes"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "mobilePayLoginEnforced", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "mobilePayLoginEnforced"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "timeAtAppActive", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "timeAtAppActive"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "shouldShowGlobalBanner", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "shouldShowGlobalBanner"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isGlobalBannerMessageAvailableInRB", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isGlobalBannerMessageAvailableInRB"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isCareersLinkAvailableInRB", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isCareersLinkAvailableInRB"), _class.prototype)), _class);
export { Common as default };